module.exports = __webpack_public_path__ + "static/whereSW-16a751714b7f2266cd0e15d61cd6ab6b.png";